import type { QuerySpec } from '@helios/powersync-client-core';

// ─── Types ───

export type AppointmentStatusType = 'normal' | 'terminal';

export interface AppointmentStatusRow {
  id: string;
  org_id: string | null;
  clinic_id: string | null;
  label: string | null;
  type: string | null;
  color_hex: string | null;
  active: number | null; // 0/1
  sort_order: number | null;
  created_at: string | null;
  updated_at: string | null;
}

// ─── Queries ───

/**
 * Fetch all appointment statuses, ordered by sort_order.
 */
export function qAppointmentStatuses(): QuerySpec<[]> {
  return {
    key: ['appointment-statuses'] as const,
    sql: `SELECT * FROM appointment_statuses ORDER BY sort_order ASC, label ASC`,
    params: [],
    watch: ['appointment_statuses'],
  };
}

// ─── Helpers ───

export function mapStatusRowToUI(row: AppointmentStatusRow) {
  return {
    id: row.id,
    name: row.label ?? '',
    type: (row.type ?? 'normal') as AppointmentStatusType,
    color: row.color_hex ?? '#22c55e',
    active: row.active === 1,
    sortOrder: row.sort_order ?? 0,
  };
}

export function mapUIToStatusColumns(ui: {
  name: string;
  type: AppointmentStatusType;
  color: string;
  active: boolean;
  sortOrder: number;
}) {
  return {
    label: ui.name,
    type: ui.type,
    color_hex: ui.color,
    active: ui.active ? 1 : 0,
    sort_order: ui.sortOrder,
    updated_at: new Date().toISOString(),
  };
}
